import { render } from "./FrenteCapela.vue?vue&type=template&id=2336ab03&scoped=true"
import script from "./FrenteCapela.vue?vue&type=script&lang=js"
export * from "./FrenteCapela.vue?vue&type=script&lang=js"

import "./FrenteCapela.vue?vue&type=style&index=0&id=2336ab03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2336ab03"]])

export default __exports__